import React from "react";
import "../styles/privacypolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <div className="privacy-content">
          <header className="contact-header">
            <section
              className="hero-section"
              style={{
                backgroundImage: ` url('https://pixeltools.in/img/carousel-1.jpg')`,
                height: "300px",
              }}
            >
              <div className="hero-overlay">
                <div className="hero-content">
                  <h1 className="refund-main-title">Privacy policy</h1>{" "}
                </div>
              </div>
            </section>
          </header>
          <div className="section-title">
            <h5>Privacy policy</h5>
          </div>

          <div className="content-box">
            <p>
              Pixel Tools is an online E-Commerce platform. Pixel Tools is
              committed to safeguarding its user(s) privacy (herein referred to 
              as "you" or "your"). Pixel Tools (herein referred to as "our" or
              "we" or "us") privacy policy describes what personal information
              is collected by us from our customers and how it will be used by
              us and third parties for further transactions. Please go through
              each point of the privacy policy before you start using the
              website or any of our services. Your use of the website or any of
              our services declares your strong consent towards every point of
              our privacy policy. The privacy policy speaks about your personal
              and non-personal information of your account. It is suggested to
              every user to go through the privacy policy along with the terms
              of use to have a better understanding of us and the use of our
              services.
            </p>

            <p>
              The terms used in this Privacy Policy have the same meanings as in
              our Terms and Conditions, which are accessible at Pixel Tools,
              unless otherwise defined in this Privacy Policy.
            </p>
          </div>

          <div className="section-title"> 
            <h5>Information Collection and Use</h5>
          </div>

          <div className="content-box">
            <p>
              When you register an account with us to gain additional features
              or to access the full-fledged services, personal and non-personal
              information would be collected when required. Personal information
              is not just confined to name, address, and date of birth but
              proportionate to our requirements. However, you have the facility
              of not sharing the information if it is highly private, excluding
              the cases when it is marked as mandatory. In such cases of leaving
              mandatory fields blank, you cannot avail our services completely.
              The reason why we collect personal information of our customers is
              to provide more effective and personalized services that will
              ensure ample happiness to every customer. We maintain the list of
              your personal data in order to facilitate customized alerts and
              preferences in providing services, offers, and to support
              customers by creating a fraud-free environment with utmost ease.
              Some part of information may be collected through the user(s) and
              it may be stored in the server logs in the form of data. This data
              is considered as reference to us to have a better understanding of
              the number of user visits to the website. A few parts of
              information might be shared with our associates. While using the
              Website, our servers (hosted by a third-party service provider)
              may collect information about your activities on the website, for
              instance, by way of cookies. In case of any advertisements or
              promotions run on the website by third parties or by any of the
              sponsors on behalf of us, they might collect the user(s)
              information that might include IP addresses, browser software,
              number of clicks, number of unique visitors, internet service
              provider, exit/referring pages, type of platform, date/time stamp,
              screen resolution, etc. for analysis that helps us provide an
              improved user experience and services. We maintain the data of
              buying and browsing activities protected on the website, which is
              not limited to user(s) contact details, profiles, and uses the
              same information to provide hassle-free, improved value-added
              services to the user(s). We have built a website with a team of
              the finest coders which makes it strong enough to withstand
              hacking and bugs. However, please note that our website is not a
              risk-proof website.
            </p>
          </div>

          <div className="section-title">
            <h5>Usage of Personal Information by Pixel Tools</h5>
          </div>

          <div className="content-box">
            <p>
              Based on the information that is provided to us, you might receive
              email alerts, SMS subscriptions from us or from third parties.
              However, we value our user(s) privacy, and you can stop receiving
              emails at any time by just clicking the "unsubscribe" option
              attached to any email that you receive from us.
            </p>
          </div>

          <div className="section-title">
            <h5>Disclosure</h5>
          </div>

          <div className="content-box">
            <p>
              We reserve the right to disclose information of any user(s) when
              forced by the government or third parties in case of any legal
              obligations.
            </p>
          </div>

          <div className="section-title">
            <h5>Sharing of User(s) Information</h5>
          </div>

          <div className="content-box">
            <p>
              As a basic ethic, we will never share any sort of user(s)
              information, whether personal or impersonal, unless we have the
              user(s) permission or under any special cases such as providing
              information on good faith or in case of any legal obligations when
              the law requires. We reserve the right to disclose information
              required to identify or proceed legally against someone who's
              caught violating the "Terms of Use" or for the reason being
              interfered in our services or rights. You will be asked to provide
              the necessary information while making use of services on our
              website. The information that you share with us is transferred and
              shared with third-party payment gateway operators through which
              the payment is generated to the user(s). The user(s) need to note
              that the mentioned operator may have access to your information
              like online purchase history/details that you do from us or our
              associates. However, extremely sensitive information of the
              user(s) like credit/debit card details is processed upon highly
              secured websites with high digital encryption, which can leave
              every transaction free of risk. However, not all the time is the
              internet medium secured, and so we request user(s) to exercise
              discretion when using the same. 
            </p>
          </div>

          <div className="section-title">
            <h5>Cookies</h5>
          </div>

          <div className="content-box">
            <p>
              Cookies are files with a small amount of data that is commonly
              used as an anonymous unique identifier. A "cookie" is a small
              piece of information stored by a web server on a web browser so it
              can be later read back from that browser. Cookies are useful for
              enabling the browser to remember information specific to a given
              user. We place both permanent and temporary cookies on your
              computer's hard drive. The cookies do not contain any of your
              personally identifiable information.
            </p>
          </div>

          <div className="section-title">
            <h5>Security of User(s) Information</h5>
          </div>

          <div className="content-box">
            <p>
              We assure that no information related to business would be
              disclosed to anyone at any point of time with respect to our
              associates.
            </p>
          </div>

          <div className="section-title">
            <h5>Security of Our Associates' Information</h5>
          </div>

          <div className="content-box">
            <p>
              We reserve the right to send mails regarding offers and services
              for our customers/clients. Also, we constantly try to improve our
              services and website functionality from time to time according to
              customer interests and satisfaction.
            </p>
          </div>

          <div className="section-title">
            <h5>Changes to This Privacy Policy</h5>
          </div>

          <div className="content-box">
            <p>
              We may update our Privacy Policy from time to time. Thus, you are
              advised to review this page periodically for any changes. We will
              notify you of any changes by posting the new Privacy Policy on
              this page. These changes are effective immediately, after they are
              posted on this page.
            </p>
          </div>

          <div className="section-title">
            <h5>Contact Us</h5>
          </div>

          <div className="content-box">
            <p>
              If you have any questions or suggestions about our Privacy Policy,
              do not hesitate to contact us.
            </p>
            {/* <div className="contact-details">
              <p><strong>Email:</strong> privacy@pixeltools.in</p>
              <p><strong>Phone:</strong> +91-XXXXXXXXXX</p>
              <p><strong>Address:</strong> Pixel Tools, [Your Address Here]</p>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
